import React, { PureComponent } from 'react';
import warning from 'warning';
import { Trans, t } from '@lingui/macro';

import chartOptionsGen from '../utils/chartOptionsGen';
import styleShare from './od-share.module.scss';

import Chart from '../utils/chartjs';

class WeekDeal extends PureComponent {
    constructor(props) {
        super(props);
        this.graphRefs = React.createRef();
        const data = this._getData(props.station);
        const selectYearMonthLength = props.selectYearMonth.length;

        this.state = {
            data,
            hasData: true,
            selectYearMonthLength,
        };
    }

    componentDidMount() {
        const ctx = this.graphRefs.current.getContext('2d');
        this.weekChart = new Chart(ctx, {
            type: 'bar',
            data: this.state.data,
            options: chartOptionsGen.options(),
        });
    }

    componentWillReceiveProps(nextProps) {
        const { selectYearMonthLength } = this.state;
        if (
            nextProps.station !== this.props.station
      || nextProps.selectYearMonth.length !== selectYearMonthLength
        ) {
            const data = this._getData(nextProps.station);
            this.setState(
                {
                    data,
                    selectYearMonthLength: nextProps.selectYearMonth.length,
                },
                () => {
                    this._updateGraph();
                },
            );
        }
    }

    _updateGraph = () => {
        const { data, hasData } = this.state;
        if (data) {
            this.weekChart.data.datasets = data.datasets;
            this.weekChart.update();
            if (!hasData) this.setState({ hasData: true });
        } else {
            this.setState({ hasData: false });
        }
    }

    _getData = (station) => {
        // init wdayList
        const { selectYearMonth, stationWdayDeal } = this.props;

        const wdayList = {};
        for (let i = 0; i < 7; i += 1) wdayList[i] = 0;
        // aggregate selected data
        selectYearMonth.forEach((item) => {
            const { year, month } = item;
            for (let i = 0; i < 7; i += 1) {
                if (
                    stationWdayDeal[station]
          && stationWdayDeal[station][year]
          && stationWdayDeal[station][year][month]
          && stationWdayDeal[station][year][month][i]
                ) wdayList[i] += stationWdayDeal[station][year][month][i];
                else {
                    warning(
                        false,
                        `Station ${station} at ${year}/${month} didn't have weekday-${i} record problem!`,
                    );
                }
            }
        });

        // if sum is 0, means it didnt have data
        const sum = Object.values(wdayList).reduce((accu, curr) => accu + curr);
        if (sum === 0) return false;

        const data = {
            labels: [
                t({ id: 'common.sun' }),
                t({ id: 'common.mon' }),
                t({ id: 'common.tue' }),
                t({ id: 'common.wed' }),
                t({ id: 'common.thu' }),
                t({ id: 'common.fri' }),
                t({ id: 'common.sat' }),
            ],
            datasets: [chartOptionsGen.genData({ data: Object.values(wdayList), label: t({ id: 'common.transaction' }) })],
        };
        return data;
    }

    render() {
        const { hasData } = this.state;
        const { width } = this.props;
        return (
            <div>
                <h3 className={styleShare.odTitle}>
                    <Trans id="od.weekdayActivity" />
                </h3>
                <canvas
                    ref={this.graphRefs}
                    id="monthDealChart"
                    width={width}
                    height="400"
                    className={styleShare.chartCanvas}
                    style={{ display: hasData ? 'block' : 'none' }}
                />
                <div
                    className={styleShare.nodata}
                    style={{
                        width: `${width}px`,
                        height: '200px',
                        display: hasData ? 'none' : 'block',
                    }}
                >
                    No Data
                </div>
            </div>
        );
    }
}

export default (WeekDeal);
